const sports = ["Futebol", "Tênis", "Artes Marciais", "Atletismo", "Basquete", "Vôlei"]

export function TrustBar() {
  return (
    <section className="border-y border-white/5 bg-card/30 py-8">
      <div className="mx-auto max-w-7xl px-6 flex flex-col md:flex-row items-center gap-6 md:gap-10">
        <p className="text-sm text-muted-foreground whitespace-nowrap">
          Da escolinha ao alto rendimento em
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {sports.map((s) => (
            <span
              key={s}
              className="text-sm font-semibold text-muted-foreground/80 tracking-wide hover:text-primary transition-colors"
            >
              {s.toUpperCase()}
            </span>
          ))}
        </div>
      </div>
    </section>
  )
}
